// Everything in this file must be imported or prefixed with window
// to avoid "Uncaught ReferenceError: <variable> is not defined"

const $ = window.$;
const _ = window._;
const Backbone = window.Backbone;

export {
    $,
    _,
    Backbone,
};
